/**
 * @desc 批量导入管理域
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: Array<defs.TheNewManagementDomainParameters>,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/wap/base/import',
    data,
  });
}

export function mock(
  data: Array<defs.TheNewManagementDomainParameters>,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/wap/base/import',
    data,
  });
}
